import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import LoginHeader from '../../../components/Header/LoginHeader.js';
import $ from 'jquery';
import { logout,login } from '../../../actions/index';
import { connect } from 'react-redux';
import classnames from 'classnames';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      email:"",
      password:"",
      isLoading: false,
      errorModalOpen: false
    };
    this.login = this.login.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.renderLoginSpin = this.renderLoginSpin.bind(this);
    this.openDangerToggle = this.openDangerToggle.bind(this);
    this.closeDangerToggle = this.closeDangerToggle.bind(this);

  }


  componentWillMount() {
        if(!this.props.user.isLoggedIn) {
        console.log(this.props.user);
      }
    }

  openDangerToggle() {
    this.setState({
      errorModalOpen:true
    })
  }

  closeDangerToggle() {
    this.setState({
      errorModalOpen:false
    })
  }

  handleEmailChange(e) {
      this.setState({
        email:e.target.value
      })
    }

  handlePasswordChange(e) {
      this.setState({
        password:e.target.value
      })
    }



  renderLoginSpin() {
    if(this.state.isLoading) {
      return (
        <i className={classnames('fa', 'fa-circle-o-notch', 'fa-spin')} ></i>
      )
    }
    else {
      return;
    }
  }


  login() {

      this.setState({
        isLoading: true
      })

      let data = {
        username:this.state.email,
        password:this.state.password
      }

      //setTimeout(()=> this.setState({ navigate: true, path:'storyCreating',isLoading:false }), 4000);

      $.ajax({
                        type: 'POST',
                        url: `https://screen.mobflic.com/v1/current-user/userpass/authenticate`,
                        data:data,
                        success: (res,a,b) => {
                          this.props.dispatch(login({username:res.result.email,customerId:res.result.id,authToken:res.result.authToken}));

                          this.setState({
                            navigate: true,
                            path:'dashboard',
                            isLoading: false
                          })

                        },
                        error: (res,a,b) => {
                          this.setState({
                            isLoading: false,
                            errorModalOpen: true,
                            email:"",
                            password:""
                          })
                          }
                    });

    }



  render() {
    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log(path);
      return <Redirect to={ "/" + path } push={true} />
    }


    return (
      <div className="app">

       <Modal isOpen={this.state.errorModalOpen}
                       className={'modal-danger '}>
                  <ModalHeader toggle={this.toggleDanger}> Authentication Failed </ModalHeader>
                  <ModalBody>
                      Your email and password does not match
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={this.closeDangerToggle}>Cancel </Button>
                  </ModalFooter>
        </Modal>

        <LoginHeader />
        <div className="app flex-row align-items-center">

          <Container>
            <Row className="justify-content-center">
              <Col md="4">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon><i className="icon-user"></i></InputGroupAddon>
                        <Input onChange={this.handleEmailChange} value={this.state.email} type="email" placeholder="Email"/>
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon><i className="icon-lock"></i></InputGroupAddon>
                        <Input onChange={this.handlePasswordChange} value={this.state.password} type="password" placeholder="Password"/>
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button style={{backgroundColor:'#6D5C7B', color:"#fff", "borderRadius":"5px"}} className="px-4" onClick={() => this.login()}> Login {this.renderLoginSpin()}</Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
    return {
        user: state.activeUser
    };
}


export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js